export const TRANSLATION_COMPONENTS = {
  "bold": <span style={{ "fontWeight": 600 }} />
};
